import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const SectionHeaderWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const RedBullet = styled('div')<{ theme?: TTheme }>`
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.reds[0]};
    flex-shrink: 0;
`

export const SectionTitle = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.greys[900]};
    text-transform: uppercase;
`
